import { render, staticRenderFns } from "./Sensations.vue?vue&type=template&id=433ed553"
import script from "./Sensations.vue?vue&type=script&lang=js"
export * from "./Sensations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports